import type React from 'react'
import { useEffect } from 'react'

interface useClickOutsideProps {
  itemRef: React.RefObject<HTMLElement>
  triggerRef: React.RefObject<HTMLElement>
  isOpen: boolean
  // todo: isOpen change to clickedOutside
  setIsOpen: (isOpen: boolean) => void
}

function useClickOutside({
  itemRef,
  triggerRef,
  isOpen,
  setIsOpen,
}: useClickOutsideProps) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        itemRef.current &&
        !itemRef.current.contains(event.target as Node) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, setIsOpen])
}

export { useClickOutside }
